import React from "react";
import Typewriter from "typewriter-effect";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import { CustomMarkdownParagraph } from "./MarkdownParagraph";

const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;

export const MessageContent = ({ message, currentAnimatedMessageId }) => {
  const text = message?.text || "";
  const hasHtml = htmlTagRegex.test(text);
  const shouldAnimate = message.id === currentAnimatedMessageId;
  const contentTopSpace = message?.sent ? "0px" : "6px";

  return (
    <Box
      sx={{
        wordBreak: "break-word",
        whiteSpace: shouldAnimate ? "pre-line" : "normal",
      }}
    >
      {shouldAnimate ? (
        <Box
          sx={{
            margin: `10px 0px 0px 0px`,
            fontSize: 14,
          }}
        >
          <Typewriter
            options={{
              strings: text,
              autoStart: true,
              delay: 30,
            }}
          />
        </Box>
      ) : hasHtml ? (
        <Box
          sx={{
            paddingTop: contentTopSpace,
            fontSize: 14,
            lineHeight: 1.45,
            paddingBottom: "4px",
            "& p": { margin: "0 0 10px 0" },
            "& p:last-of-type": { marginBottom: 0 },
            "& div": { margin: 0 },
            "& strong": { fontWeight: 700 },
            "& br": {
              display: "block",
              marginBottom: "4px",
            },
          }}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      ) : (
        <ReactMarkdown
          components={{
            p: ({ node, ...props }) => (
              <CustomMarkdownParagraph
                isSent={message?.sent}
                node={node}
                {...props}
              />
            ),
          }}
        >
          {text}
        </ReactMarkdown>
      )}
    </Box>
  );
};

MessageContent.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  currentAnimatedMessageId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};
